<template>
	<div class="default z-flex z-flex-col z-flex-center">
		<img class="img" :src="defaultImg" />
		<p class="text" v-html="defaultText"></p>
		<div class="btn-wrap">
			<el-button class="btn" type="primary" :plain="index!=0" v-for="(item,index) in defaultBtnList" :key="index"
				@click="toUrl(item)">
				{{item.btnText}}
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
  name: 'defaultCon',
  props: {
	defaultImg:{ //缺省图
		type: String,
		default: 'https://www.pai2345.com/static/web/manual-retouching/images/pic-8.png'
	},
	defaultText:{ //缺省文字
		type: String,
		default: ''
	},
	defaultBtnList:{
		type: Array,
		default: [
			{
				btnText:'',
				btnUrl:'',
				ifRoute:true,
			}
		]
	},
  },
  data () {
    return {
		
    }
  },
  methods: {
	toUrl(item){
		if(item.ifRoute){
			this.$router.push({path: item.btnUrl})
		}else{
			window.location = item.btnUrl
		}
		
	}
  },
}
</script>

<style lang="scss" scoped>
	.default{
		height:500px;
		.img{
			margin-bottom: 30px;
		}
		.text{
			color: #999;
			font-size: 22px;
			text-align: center;
			margin-bottom: 30px;
		}

	}
</style>
